import { c as _c } from "react/compiler-runtime";
import CheckMark from "@/widgets/inquiry-landing/ui/atoms/CheckMark";
type CheckIconProps = {
  /** 비활성(별도 구매) 톤이면 회색, 기본은 브랜드 퍼플 */
  isMuted?: boolean;
};

/** 요금제 기능 리스트용 체크 — 공용 CheckMark 에 크기/색만 지정(#6B00D7 / #C7C7CE). */
const CheckIcon = t0 => {
  const $ = _c(2);
  const {
    isMuted: t1
  } = t0;
  const isMuted = t1 === undefined ? false : t1;
  const t2 = `mt-[6px] h-[11px] w-[11px] shrink-0 ${isMuted ? "text-[#c7c7ce]" : "text-primary-600"}`;
  let t3;
  if ($[0] !== t2) {
    t3 = <CheckMark className={t2} />;
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  return t3;
};
export default CheckIcon;